export default __webpack_public_path__ + "static/media/Level27.36f944bf.svg";